// removed by extract-text-webpack-plugin
module.exports = {"base":"Dialog_base--nBYAI","isOpened":"Dialog_isOpened--2qGo9","wrapper":"Dialog_wrapper--2kwE8","body":"Dialog_body--2rVeq","background":"Dialog_background--2EIpE","header":"Dialog_header--wtbLK","title":"Dialog_title--3lvpw","close":"Dialog_close--34L06","content":"Dialog_content--gbSH3","footer":"Dialog_footer--30LID","button":"Dialog_button--25pTP","overlay":"Dialog_overlay--1L3g5"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-mt-bootstrap/lib/components/Dialog/Dialog.css
// module id = 1774
// module chunks = 16